import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { FormConfigChangeDialogData } from '../../interfaces/dialog-data.interface';

@Component({
  selector: 'app-form-config-change-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './form-config-change-modal.component.html',
})
export class FormConfigChangeModalComponent {
  constructor(
    private dialogRef: MatDialogRef<FormConfigChangeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormConfigChangeDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
